import styled, { css } from 'styled-components';
import { complementaryColor, fontSize, tertiaryColor, warningColor } from '@styles/utils';

interface TextareaProps {
  error: boolean;
}

export const TextArea = styled.textarea<TextareaProps>`
  display: block;
  min-height: 80px;
  width: 100%;
  padding: 15px 20px;
  margin: 0;
  border: 1px solid ${tertiaryColor(300)};
  border-radius: 2px;
  box-sizing: border-box;
  font-family: inherit;
  ${fontSize.label};
  color: ${tertiaryColor(700)};
  line-height: 1;
  outline: none;
  background-color: ${tertiaryColor(100)};

  &::placeholder {
    font-family: inherit;
    ${fontSize.label};
    opacity: 0.4;
    color: ${tertiaryColor(700)};
  }

  &:disabled {
    color: ${tertiaryColor(700)};
    background-color: ${complementaryColor('white')};
    cursor: not-allowed;
    border: none;
  }

  ${props =>
    props.error &&
    css`
      border-color: ${warningColor()};
    `}
`;
